export default "__VITE_ASSET__9jUH5E2l__"